import * as React from 'react';
import BackBreadcrumb from './BackBreadcrumb';
import { getCatalog } from '@/redux/modules/catalog';
import { getCatalogUrl } from '@/utils/urls';
import { getPastUrl } from '@/redux/modules/route';
import isEqual from 'react-fast-compare';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    className?: string;
};

const MegaBreadcrumb = ({ catalogId, className }: Props) => {
    const { title } = useSelector((state) => getCatalog(state, catalogId), isEqual);
    const { pathname: pastUrlPathname } = useSelector(getPastUrl);

    const { formatMessage } = useIntl();

    let megaBreadcrumb;
    if (
        pastUrlPathname.includes('/search') ||
        pastUrlPathname.includes('/c/') ||
        pastUrlPathname.includes('/price-guide')
    ) {
        megaBreadcrumb = (
            <BackBreadcrumb className={className} label={formatMessage({ id: 'back_to_search' })} type="back" />
        );
    } else if (pastUrlPathname.includes('catalog') && pastUrlPathname.includes(`${catalogId}`)) {
        megaBreadcrumb = (
            <BackBreadcrumb className={className} label={formatMessage({ id: 'back_to_auction' })} type="back" />
        );
    } else {
        const catalogUrl = getCatalogUrl(catalogId, title);
        megaBreadcrumb = (
            <BackBreadcrumb
                className={className}
                label={formatMessage({ id: 'view_auction' })}
                target={catalogUrl}
                type="link"
            />
        );
    }
    return megaBreadcrumb;
};

export default React.memo<Props>(MegaBreadcrumb);
